import racketlyDevicesImage from "../../assets/feature1.webp";

export const howToUseRacketly = {
  id: 7,
  slug: "how-to-use-racketly",
  title: "How to Track Tennis & Padel Matches with Racketly",
  excerpt: "Just downloaded Racketly? Here is everything you need to know to start tracking your tennis and padel matches like a pro.",
  seoTitle: "How to Track Tennis & Padel with Racketly | Racketly",
  seoDescription: "Get started with Racketly on iPhone and Apple Watch. Set up a tennis or padel match, log points from your wrist, correct mistakes and review your match history.",
  date: "2026-01-04",
  updatedAt: "2026-10-06",
  category: "Guide",
  image: racketlyDevicesImage,
  imageWidth: 780,
  imageHeight: 1688,
  imageAlt: "Racketly running on an iPhone and Apple Watch",
  imageCaption: "Racketly match tracking on iPhone and Apple Watch.",
  imageCredit: "Racketly",
  imagePosition: "center 64%",
  content: `
  <p class="mb-4">Welcome to Racketly! Whether you are a weekend warrior or a competitive league player, tracking your improved performance starts here. This guide will walk you through your first match.</p>

  <h2 class="text-xl font-bold mb-3 mt-6">1. Quick Setup</h2>
  <p class="mb-4">Before you step on the court, make sure you've granted the necessary permissions. Racketly uses <strong>HealthKit</strong> to track your calories and heart rate during the match. When prompted, allow the health data categories you want to record.</p>

  <h2 class="text-xl font-bold mb-3 mt-6">2. On the Court</h2>
  <p class="mb-4">Open Racketly on your <strong>Apple Watch</strong>. You'll see the sport picker. Tap your sport to begin. You can then choose your scoring format (e.g., 1 set, 3 sets, tie-break rules).</p>
  
  <h2 class="text-xl font-bold mb-3 mt-6">3. During Play</h2>
  <p class="mb-4">Tracking is designed to be distraction-free:</p>
  <ul class="list-disc list-inside mb-4 ml-4">
    <li><strong>Add Point:</strong> Tap the player or team that won the point.</li>
    <li><strong>Undo:</strong> Made a mistake? Use Undo to correct the score.</li>
  </ul>

  <h2 class="text-xl font-bold mb-3 mt-6">4. Post-Match Analysis</h2>
  <p class="mb-4">Once you finish the match and save it, open the Racketly app on your <strong>iPhone</strong>. Review your saved match history and the score and performance details recorded during your session.</p>
`,
};
